import { useMemo } from "react";
import { ListVendorDto } from "../models/vendors.models";
import { useSearch } from "./SearchBox.hook";

export function useFilteredVendors(vendors: ListVendorDto[]) {
	const { query } = useSearch();

	const filteredVendors = useMemo(() => {
		if (query && query.length > 0) {
			const lowerQuery = query.toLowerCase();
			return vendors?.filter(vendor =>
				(vendor.Name && vendor.Name.toLowerCase().includes(lowerQuery)) ||
				(vendor.VendorType && vendor.VendorType.toLowerCase().includes(lowerQuery))
			) || [];
		}

		return vendors || [];
	}, [query, vendors]);

	return { filteredVendors, showNoResults: query && query.length > 0 && filteredVendors.length === 0 };
}
